import React, { useContext, useEffect, useRef, useState } from "react"
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from "reactstrap"
import { AuthContext } from "../../context/AuthContext"
import { TipoAgendaContext } from "../../context/TipoAgendaContext"
import { CreateTipoAgendaType } from "../../context/hooks/useTipoAgenda"

interface Props {
    isOpen: boolean
    toggle: () => void
    onCreated?: () => void
}

export const CreateTipoAgendaModal: React.FC<Props> = ({ isOpen, toggle, onCreated }) => {
    const { objUserTk } = useContext(AuthContext)
    const { createTipoAgenda } = useContext(TipoAgendaContext)

    const isMountedRef = useRef(true)
    const [submitting, setSubmitting] = useState(false)

    const [form, setForm] = useState<CreateTipoAgendaType>({
        description: "",
        empresaId: objUserTk.EmpresaId,
    })

    useEffect(() => {
        isMountedRef.current = true
        return () => {
            isMountedRef.current = false
        }
    }, [])

    useEffect(() => {
        if (isOpen) {
            setForm({ description: "", empresaId: objUserTk.EmpresaId })
            setSubmitting(false)
        } else {
            setSubmitting(false)
        }
    }, [isOpen, objUserTk.EmpresaId])

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const closeThen = (cb?: () => void) => {
        toggle()
        if (cb) {
            // Deixa o portal do Modal desmontar antes de atualizar lista/página
            requestAnimationFrame(() => {
                if (isMountedRef.current) cb()
            })
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (submitting) return

        const desc = (form.description || "").trim()
        if (!desc) return

        setSubmitting(true)
        try {
            const ok = await createTipoAgenda({
                ...form,
                description: desc,
                empresaId: Number(form.empresaId),
            })

            if (ok) {
                // fecha primeiro, atualiza depois (evita corrida do portal)
                closeThen(onCreated)
            }
        } finally {
            if (isMountedRef.current) setSubmitting(false)
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={submitting ? undefined : toggle} backdrop="static" size="lg">
            <ModalHeader toggle={submitting ? undefined : toggle}>Adicionar novo tipo de agenda</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label className="form-control-label">Tipo de agenda:</Label>
                        <Input
                            className="form-control-alternative"
                            name="description"
                            value={form.description}
                            onChange={onChange}
                            placeholder="Ex: Missa, Festa de formatura…"
                            required
                            disabled={submitting}
                            autoFocus
                        />
                    </FormGroup>

                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: "#585858", color: "#fff" }} type="submit" disabled={submitting}>
                            {submitting ? "Salvando..." : "Criar Tipo de Agenda"}
                        </Button>

                        <Button
                            type="button"
                            style={{ background: "#585858", color: "#fff" }}
                            className="ml-2"
                            onClick={() => closeThen()}
                            disabled={submitting}
                        >
                            Cancelar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default CreateTipoAgendaModal